import RestCardCategory from "./RestCardCategory";

function RestCategories({ onChange, _, visibleCats }) {
  if (!visibleCats) return null;

  const cardCategories = [];
  for (const cat of visibleCats.values()) {
    cardCategories.push(
      <RestCardCategory key={cat.id} onChange={onChange} record={cat} />,
    );
  }

  return <div className="grid grid-cols-2 w-full">{cardCategories}</div>;
}

export default RestCategories;
